<div *transloco="let t">
   <div #scrollToMe class="t-question flex flex-inline flex-row items-center scroll-m-4 mb-4" tabindex="-1">
      @if (qanda.question) {
      <!-- prettier-ignore -->
         <svg class="shrink-0 inline me-2 w-8" viewBox="0 0 31 30" [attr.aria-label]="t('question.title')" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_3194_1386)">
               <path
                  d="M15.1054 2.5C8.20544 2.5 2.60544 8.1 2.60544 15C2.60544 21.9 8.20544 27.5 15.1054 27.5C22.0054 27.5 27.6054 21.9 27.6054 15C27.6054 8.1 22.0054 2.5 15.1054 2.5ZM15.1054 6.25C17.1804 6.25 18.8554 7.925 18.8554 10C18.8554 12.075 17.1804 13.75 15.1054 13.75C13.0304 13.75 11.3554 12.075 11.3554 10C11.3554 7.925 13.0304 6.25 15.1054 6.25ZM15.1054 24C11.9804 24 9.21794 22.4 7.60544 19.975C7.64294 17.4875 12.6054 16.125 15.1054 16.125C17.5929 16.125 22.5679 17.4875 22.6054 19.975C20.9929 22.4 18.2304 24 15.1054 24Z"
                  fill="black" />
            </g>
            <defs>
               <clipPath id="clip0_3194_1386">
                  <rect width="30" height="30" fill="white" transform="translate(0.105438)" />
               </clipPath>
            </defs>
         </svg>

         <h2 class="t-question-text inline font-bold text-2xl text-black">
            {{ qanda.question }}
         </h2>
      }
   </div>
   @if(qanda.answer && qanda.answer.answer) {
      <span aria-live="polite" aria-atomic="true" class="sr-only">{{ t('summary.loaded') }}</span>
   } @else {
      @for(status of qanda.statusMessages; track status) {
         <div #scrollToMe class="t-status-container" [ngClass]="{'t-error': status.error}">
            <app-status-message [qanda]="qanda" [status]="status" [shouldShowLoader]="$last && !(qanda.answer && qanda.answer.answer) && !status.error"></app-status-message>
         </div>
      }
   }
   @if(qanda.answer && qanda.answer.answer) {
      @if(qanda.answer.context) {
         @for(context of qanda.answer.context; track context) {
            <div class="t-answer-message mb-2 border-2 rounded-md inline-flex items-center p-2 w-full"
               [ngClass]="{'gradient-border-blue bg-cdra-blue-light-200': context.type !== 'DEBUG', 'border-red-500 bg-red-200': context.type === 'DEBUG'}">
               @if(context.type !== 'DEBUG') {
               <!-- prettier-ignore -->
               <svg class="shrink-0 w-5 h-5 me-1" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                     d="M10.5523 0.5C4.75407 0.5 0.0527344 5.20133 0.0527344 10.9996C0.0527344 16.7978 4.75407 21.5 10.5523 21.5C16.3505 21.5 21.0527 16.7978 21.0527 10.9996C21.0527 5.20133 16.3505 0.5 10.5523 0.5ZM12.7381 16.7729C12.1976 16.9862 11.7674 17.148 11.4447 17.26C11.123 17.372 10.7487 17.428 10.323 17.428C9.66873 17.428 9.1594 17.268 8.79673 16.9489C8.43407 16.6298 8.25362 16.2253 8.25362 15.7338C8.25362 15.5427 8.26696 15.3471 8.29362 15.148C8.32118 14.9489 8.36473 14.7249 8.42429 14.4733L9.10073 12.084C9.16029 11.8547 9.21185 11.6369 9.25274 11.4342C9.29362 11.2298 9.31318 11.0422 9.31318 10.8716C9.31318 10.5676 9.25007 10.3542 9.12473 10.2342C8.99762 10.1142 8.75851 10.0556 8.40207 10.0556C8.22785 10.0556 8.04829 10.0813 7.86429 10.1356C7.68207 10.1916 7.52385 10.2422 7.39407 10.292L7.57273 9.556C8.0154 9.37556 8.4394 9.22089 8.84385 9.09289C9.24829 8.96311 9.63051 8.89911 9.99051 8.89911C10.6403 8.89911 11.1416 9.05733 11.4945 9.37022C11.8456 9.684 12.0225 10.092 12.0225 10.5933C12.0225 10.6973 12.0101 10.8804 11.9861 11.1418C11.9621 11.404 11.9167 11.6431 11.851 11.8627L11.1781 14.2449C11.123 14.436 11.0741 14.6547 11.0296 14.8991C10.9861 15.1436 10.9647 15.3302 10.9647 15.4556C10.9647 15.772 11.035 15.988 11.1772 16.1027C11.3176 16.2173 11.5638 16.2751 11.9123 16.2751C12.0767 16.2751 12.2607 16.2458 12.4687 16.1889C12.675 16.132 12.8243 16.0813 12.9185 16.0378L12.7381 16.7729ZM12.619 7.10356C12.3052 7.39511 11.9274 7.54089 11.4856 7.54089C11.0447 7.54089 10.6643 7.39511 10.3478 7.10356C10.0332 6.812 9.87407 6.45733 9.87407 6.04311C9.87407 5.62978 10.0341 5.27422 10.3478 4.98C10.6643 4.68489 11.0447 4.53822 11.4856 4.53822C11.9274 4.53822 12.3061 4.68489 12.619 4.98C12.9327 5.27422 13.0901 5.62978 13.0901 6.04311C13.0901 6.45822 12.9327 6.812 12.619 7.10356Z"
                     fill="url(#paint0_linear_3505_5222)" />
                  <defs>
                     <linearGradient id="paint0_linear_3505_5222" x1="10.5527" y1="0.5" x2="10.5527" y2="21.5"
                        gradientUnits="userSpaceOnUse">
                        <stop stop-color="#68B7C5" />
                        <stop offset="1" stop-color="#155C9A" />
                     </linearGradient>
                  </defs>
               </svg>
               }
               <div class="flex flex-col relative">
                  <p class="line-clamp-2" #context [attr.id]="'context_' + $index" [attr.data-id]="'context_' + $index"
                     [ngClass]="{'line-clamp-none': context.readmore === false}" [innerHTML]="context.message"></p>
                  @if(context.readmore) {
                  <button
                     class="t-answer-message-context-read-more absolute bg-gradient-to-l from-cdra-blue-light-200 from-85% ps-6 place-self-end bottom-0 font-bold text-cdra-blue-light-main underline"
                     aria-expanded="false" [attr.aria-controls]="'source_more_' + context.type"
                     (click)="readMore($event, context)">{{ t('sources.selectedsource.readmore') }}</button>
                  }
               </div>
            </div>
         }
      }
   }
   @if(qanda.answer && qanda.answer.results && qanda.answer.results.length > 0) {
      <app-sources [selectedSource]="selectedSource" [question]="qanda.question"
         [answer]="qanda.answer"></app-sources>
   }

   @if(qanda.answer && qanda.answer.answer) {
      <div #scrollToMe @fadeIn class="t-answer answer flex flex-col mb-8 scroll-m-" tabindex="-1">
         <div class="flex items-center w-full mt-8 mb-2">
            <!-- prettier-ignore -->
            <svg aria-hidden="true" class="inline me-2 text-cdra-blue-light-main h-5" viewBox="0 0 31 30"
               fill="currentColor" xmlns="http://www.w3.org/2000/svg">
               <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M20.4851 18.6146C14.819 18.6146 10.2425 14.02 10.2425 8.37207C10.2425 14.02 5.64793 18.6146 0 18.6146C5.64793 18.6146 10.2425 23.1911 10.2425 28.839C10.2425 23.1911 14.819 18.6146 20.4851 18.6146Z" />
               <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M31.0001 23.8992C27.8946 23.8992 25.3885 21.3749 25.3885 18.2876C25.3885 21.3749 22.8641 23.8992 19.7769 23.8992C22.8641 23.8992 25.3885 26.4054 25.3885 29.5108C25.3885 26.4054 27.8946 23.8992 31.0001 23.8992Z" />
               <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M27.7676 6.82836C23.9902 6.82836 20.9392 3.77739 20.9392 0C20.9392 3.77739 17.8882 6.82836 14.1108 6.82836C17.8882 6.82836 20.9392 9.87933 20.9392 13.6567C20.9392 9.87933 23.9902 6.82836 27.7676 6.82836Z" />
            </svg>
            <h3 class="inline text-xl text-black font-bold prose" [innerHTML]="t('answer.title')"></h3>
         </div>
         <div class="flex flex-col font-normal text-black">
            <app-answer [parent]="this" [answer]="qanda.answer.answer" [language]="qanda.answer.language ?? 'en'"></app-answer>
            <div class="self-end mt-4">
               <app-action-bar [qanda]="qanda"></app-action-bar>
            </div>
         </div>
      </div>
   }
   @if(qanda.answer && qanda.answer.moreQuestions && qanda.answer.moreQuestions.length > 0) {
      <app-more-questions @fadeIn [questions]="qanda.answer.moreQuestions" [language]="qanda.answer.language ?? 'en'"></app-more-questions>
   }

</div>